<template>
    <a-modal title="修改状态点属性"
             :width="620"
             :visible="visible"
             :maskClosable="false"
             @ok="onOk"
             @cancel="onCancel">
        <a-form :form="form" class="pick-100 form-input about">
            <a-row>
                <a-col :span="24">
                    <a-form-item label="状态点名称" v-bind="formItemOneLayout">
                        <a-input v-decorator="['name',{initialValue:formData.name, rules: [{ required: true, message: '请输入状态点名称'}]}]"/>
                    </a-form-item>
                </a-col>
            </a-row>
            <a-row>
                <a-col :span="12">
                    <a-form-item class="form-item-slim" label="特性" v-bind="formItemLayout">
                        <a-select :options="specialTypeOptions" allowClear v-decorator="['specialType',{initialValue:formData.specialType}]"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item class="form-item-slim" label="参数" v-bind="formItemLayout">
                        <a-input v-decorator="['objectIdsParam',{initialValue:formData.objectIdsParam}]"/>
                    </a-form-item>
                </a-col>
            </a-row>
            <WFIconSelector @change="onChangeIcon" />
        </a-form>
    </a-modal>
</template>
<script>
import WFIconSelector from './WFIconSelector'
import * as WFC from './js/WFConstants'

export default {
  components: {
    WFIconSelector
  },
  props: {
  },
  data () {
    return {
      formItemLayout: {
        labelCol: {
          md: { span: 8 }
        },
        wrapperCol: {
          md: { span: 12 }
        }
      },
      formItemOneLayout: {
        labelCol: {
          md: { span: 4 }
        },
        wrapperCol: {
          md: { span: 19 }
        }
      },
      specialTypeOptions: [
        { value: WFC.WF_ACTIVITY_SPECIAL_TYPE_CIRCLE_END, label: '分流结束' }
      ],
      form: this.$form.createForm(this),
      formData: {
        name: '',
        specialType: '',
        objectIdsParam: ''
      },
      wfNode: null,
      visible: false
    }
  },
  methods: {
    show (wfNode) {
      this.wfNode = wfNode
      this.visible = true
      this.onRestForm()
      this.formData.name = this.wfNode.getName()
      this.wfNode.pushWFAttributes(this.formData)
    },
    onRestForm () {
      this.formData.name = ''
      this.formData.specialType = ''
      this.formData.objectIdsParam = ''

      this.form.resetFields()
    },
    onOk () {
      this.form.validateFields((err, values) => {
        if (err) {
          return
        }
        let data = this.form.getFieldsValue()
        this.formData = Object.assign(this.formData, data)
        this.wfNode.setName(data.name)
        this.wfNode.fixLayout()
        this.wfNode.setWFAttributes('FORM', this.formData)
        this.wfNode.setWFAttributes('SPECIAL_TYPE', this.formData.specialType)
        this.wfNode.updateXmlNode()
        this.visible = false
      })
    },
    onCancel () {
      this.visible = false
    },
    onChangeIcon (path) {
      this.wfNode.setIcon(path)
      this.onOk()
    }
  }
}
</script>
<style scoped lang="less">
    .form-item-slim {
        margin-bottom: 8px
    }
</style>
